module.exports = __webpack_public_path__ + "img/parcel-at-distribution-center.02ad9abc.svg";